import React from 'react';
import UserRolesTable from '../tables/UserRolesTable';
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import pageStyles from './pageStyles';

function UserManagementPage() {
  return (
    <>
      <Typography sx={pageStyles.label} component="h1" variant="h4" align="center">
        <InfoOutlinedIcon fontSize="medium" color="primary" />
        Users:
      </Typography>
      <UserRolesTable />
    </>
  );
}

export default UserManagementPage;
